import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageUserService {
  api: string;
  apiModule: string;

  constructor(protected http: HttpClient) {
    this.api = environment.identityApiUrl;
    this.apiModule = environment.customerApiUrl;
  }

  public getUserPermission(): Observable<any> {
    return this.http.get(`${this.api}/account/get-partner-roles`);
  }

  public addNewUser(userForm: any): Observable<any> {
    return this.http.post(`${this.api}/account/save-partner-user`, userForm);
  }

  public updatePermission(permission: Object): Observable<any> {
    return this.http.post(`${this.api}/account/insert-affiliate-permission`, permission);
  }

  public getListTableUser(): Observable<any> {
    return this.http.get(`${this.api}/account/get-partner-users`);
  }

  public getUserRole(userId): Observable<any> {
    return this.http.post(`${this.api}/account/get-selected-user-roles`, userId);
  }
}
